export default "__VITE_ASSET__DQk7C$Xl__"